export default __webpack_public_path__ + "static/waitingnew-19fd38128b3dfe659a82dbcfe254bb06.svg";